import { render, staticRenderFns } from "./yearAndMonthSummaryInfo.vue?vue&type=template&id=28e2b76e&scoped=true&"
import script from "./yearAndMonthSummaryInfo.vue?vue&type=script&lang=js&"
export * from "./yearAndMonthSummaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./yearAndMonthSummaryInfo.vue?vue&type=style&index=0&id=28e2b76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2b76e",
  null
  
)

export default component.exports